export enum WORK_ORDER_HOOK {
  ASSET_REQUESTS,
  ASSET_TYPES,
  FILE_FORMATS,
  LANGUAGES,
  POSITIONS,
  REGIONS,
  STORE_TYPES,
}
